import { useEffect, useState } from 'react';
import { CoachAPI } from '../../../api/CoachAPI';
import { useSelector } from 'react-redux';
import styles from '../../../styles/modules/Children.module.css';
import dayjs from 'dayjs';
import defaultProfileImg from '../../../assets/images/profile-picture.png';
import { VscPersonAdd } from "react-icons/vsc";
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog.jsx';
import { RiEdit2Fill, RiImageEditFill } from 'react-icons/ri';
import { FormControl, FormHelperText, InputLabel, Menu, MenuItem, Select, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer.js';
import Loader from '../../../component/Loader.jsx';
import * as Yup from 'yup';
import { MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router';
import { CiMenuKebab } from "react-icons/ci";

const initialValue = {
  firstName: '',
  lastName: '',
  dateOfBirth: dayjs(new Date()),
  relation: ''
}

const validationObj = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  relation: Yup.string().required("Relation is required"),
})


const ChildrenList = () => {
  const userInfo = useSelector((store) => store.user.userInfo);
  const [children, setChildren] = useState([]);
  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false,
  });
  const [openPopup, setOpenPopup] = useState({ isOpen: false, isEdit: false });
  const [image, setImage] = useState("");
  const [imagePre, setImagePre] = useState('');
  const [childData, setChildData] = useState(initialValue);
  const [fieldErrors, setFieldErrors] = useState({});
  const dispatch = useDispatch();
  const navigato = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);


  const handleCollectChildData = (event) => {
    const { name, value } = event?.target;
    setChildData({ ...childData, [name]: value });
  };

  const startLoading = (key) => {
    setLoadingState((prev) => ({ ...prev, [key]: true }));
  }
  const finishLoading = (key) => {
    setLoadingState((prev) => ({ ...prev, [key]: false }));
  }

  const findAllChildren = async () => {
    try {
      startLoading("loading1");
      const response = await CoachAPI.findAllChildren(userInfo?.userId);
      setChildren(response.Data);
    } catch (error) {

    } finally {
      finishLoading("loading1");
    }
  }
  const getFormattedDate = (date) => {
    if (typeof date === 'string') {
      return date;
    } else {
      return `${date.$y}-${String(Number(date.$M) + 1).padStart(2, '0')}-${String(date.$D).padStart(2, '0')}`
    }
  }


  const handleAddChild = async () => {
    try {
      await validationObj.validate(childData, { abortEarly: false });
      const reqChildData = {
        firstName: childData.firstName,
        lastName: childData.lastName,
        dob: getFormattedDate(childData.dateOfBirth),
        guardianId: userInfo?.userId,
        relationshipType: childData.relation
      }

      startLoading("loading2");
      const response = await CoachAPI.postAddChild(reqChildData, image);
      setChildren(prev => [...prev, response.Data]);
      setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit });
      setChildData(initialValue);
    } catch (error) {
      let errObj = {};
      error.inner.forEach(err => {
        errObj[err.path] = err.message
      })
      setFieldErrors(errObj);
    } finally {
      finishLoading("loading2");
    }
  }

  const handleEditChild = async () => {
    try {
      startLoading("loading2");
      await validationObj.validate(childData, { abortEarly: false });
      const reqChildData = {
        firstName: childData.firstName,
        lastName: childData.lastName,
        dob: getFormattedDate(childData.dateOfBirth),
        guardianId: userInfo?.userId,
        relationshipType: childData.relation,
        childrenId: childData.childrenId   
      }
      const response = await CoachAPI.putUpdateChild(reqChildData, image);
      setChildren(children.map(item => item.childrenId === childData.childrenId ? response.Data : item))

    } catch (error) {
      let errObj = {};
      error.inner.forEach(err => {
        errObj[err.path] = err.message
      })
      setFieldErrors(errObj);
    } finally {
      finishLoading("loading2");
      setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit });
      setChildData(initialValue);
    }
  }

  const handleDeleteChild = async() => {
     try{
       startLoading("loading2");
       await CoachAPI.deleteChild(userInfo.userId, childData.childrenId);
       setChildren(prev => prev.filter(item => item.childrenId !== childData.childrenId));
     }catch(error){
         console.log(error);
     }finally{
       finishLoading("loading2");
     }
  };

  useEffect(() => {
    if (userInfo.userId) {
      findAllChildren();
    }
  }, [userInfo.userId])

  const option = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }


  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const maxSizeInMB = 5;
    if (file.type === "image/webp" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif") {

      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > maxSizeInMB) {
        dispatch(rootAction.setWarningMessage({ type: 'info', content: "upload image under 5 MB" }));
      }
      else {
        setImage(file);
        setImagePre(URL.createObjectURL(file));
      }
    } else {
      dispatch(rootAction.setWarningMessage({ type: 'warning', content: "upload .jpg, .jpeg, .png, .gif,.webp file" }));
    }
  };
  if (loadingState.loading1) {
    return <Loader />
  }
  return (
    <div className={styles['children_container']}>
      {loadingState.loading2 && <Loader />}
      <div className={styles['children_header']}>
        <h1>My Kids</h1>
        <button type='button' onClick={() => setOpenPopup({ isOpen: true, isEdit: false })}><VscPersonAdd className={styles['add_child_icon']} />Add Kid</button>
      </div>
     {children?.length == 0 ?
      <div className={styles['children_not_found']}>
        <p>No kid found.</p>
      </div>
      :
      <div className={styles['children_list_con']}>
        {children?.map((child, index) =>
          <div key={index} onClick={() => navigato(`/kid-profile/${child.childrenId}`)} className={`${styles['card']} ${styles['wallet']}`}>
            <CiMenuKebab className={styles['children_card_edit_icon']}
              onClick={(e) => {
                e.stopPropagation()
                setChildData({
                  firstName: child.firstName,
                  lastName: child.lastName,
                  childrenId: child.childrenId,
                  dateOfBirth: child.dob,
                  relation: child.relationshipType,
                  guardianId: child.guardianId
                });
                setImagePre(
                  child?.profileImage
                    ?
                    import.meta.env.VITE_APP_BASE_URL + '/user/user-profile-img/' + child?.profileImage
                    :
                    defaultProfileImg
                );
                setOpenMenu(e.currentTarget);
              }
              } />
            <div className={styles['overlay']}></div>
            <div className={styles['circle']}>
              <img src={child?.profileImage
                ?
                import.meta.env.VITE_APP_BASE_URL + '/user/user-profile-img/' + child?.profileImage
                :
                defaultProfileImg} alt="" />

            </div>
            <h2>{child?.firstName + " " + child?.lastName}</h2>
            <p>{new Date(child?.dob).toLocaleDateString('en-US', option)}</p>
          </div>)}
      </div>}
      <CustomDialog
        isOpen={openPopup.isOpen}
        onClose={() => setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit })}
        onCancel={() => {
          setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit });
          setChildData(initialValue)
          setFieldErrors({});
        }}
        onSubmit={openPopup.isEdit ? handleEditChild : handleAddChild}
        title={openPopup.isEdit ? "Edit kid" : "Add kid"}
      >
        <div className={styles['add_children_form']}>
          <div className="user-profile-image">
            <label htmlFor="file_upload" className="profile_image_edit">
              <RiImageEditFill className="profile_image_edit_icon" />
            </label>
            <label className="profile_image_preview">
              <img
                loading="lazy"
                src={imagePre}
                alt=""
              />
            </label>
            <input
              type="file"
              id="file_upload"
              name="image"
              onChange={handleImageUpload}
            />
          </div>
          <div className={styles['child_name']}>
            <TextField
              error={fieldErrors['firstName']}
              helperText={fieldErrors['firstName'] && fieldErrors['firstName']}
              className={styles['form_text_field_theme']}
              fullWidth
              label="First name"
              name='firstName'
              value={childData?.firstName || ''}
              onChange={handleCollectChildData}
            />

            <TextField
              error={fieldErrors['lastName']}
              helperText={fieldErrors['lastName'] && fieldErrors['lastName']}
              className={styles['form_text_field_theme']}
              fullWidth
              label="Last name"
              name='lastName'
              value={childData?.lastName || ''}
              onChange={handleCollectChildData}
            />

          </div>
          <div className={styles['chid_dob_relation']}>
            <FormControl
              error={fieldErrors['relation']}
              fullWidth data-testid="game-dropdown"
              className={styles['form_dropdown_input_theme']}>

              <InputLabel id="demo-simple-select-autowidth-label">Relation</InputLabel>
              <Select
                labelId="demo-simple-select-autowidth-label"
                id="demo-simple-select-autowidth"
                value={childData?.relation || ''}
                onChange={handleCollectChildData}
                fullWidth
                label="Relation"
                name='relation'
              >
                <MenuItem value="father">Father</MenuItem>
                <MenuItem value="mother">Mother</MenuItem>
                <MenuItem value="grand_father">Grand Father</MenuItem>
                <MenuItem value="grand_mother">Grand Mother</MenuItem>
              </Select>
              {
                fieldErrors['relation'] &&
                <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['relation']}</FormHelperText>
              }
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className={styles['form_date_picker_theme']}
                value={dayjs(childData.dateOfBirth)}
                onChange={(e) => handleCollectChildData({ target: { name: 'dateOfBirth', value: e } })}
                label="Date of Birth"
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
          </div>
        </div>
      </CustomDialog>
      <Menu
        sx={{ left: -55 }}
        id="custom-dropdown"
        anchorEl={openMenu}
        open={Boolean(openMenu)}
        onClose={() => {
          setOpenMenu(null);
        }}
        MenuListProps={{
          "aria-labelledby": "custom-dropdown-button",
        }}
      >
        <MenuItem onClick={() => {
          setOpenPopup({ isOpen: true, isEdit: true });
          setOpenMenu(null);
        }}><RiEdit2Fill className='court_edit_icon' /> Edit</MenuItem>
        <MenuItem onClick={() => {
          handleDeleteChild();
          setOpenMenu(null);
        }}><MdDelete className='court_delete_icon' /> Delete</MenuItem>
      </Menu>
    </div>
  )
}

export default ChildrenList